module.exports = __webpack_public_path__ + "img/6.4cea2fe6.png";